import { RHFAutoCompleteVirtualize } from '@openx/components-core/lib/AutoComplete/RHFAutoCompleteVirtualize.tsx';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type Publisher, useAudienceInsights } from '../../context/audienceInsights.ts';

export function PublisherSelector() {
  const { t } = useTranslation();
  const { publishers, isReportGenerated, changePublisher } = useAudienceInsights();

  const handlePublisherChange = useCallback(
    (_: unknown, publisher: Publisher) => changePublisher(publisher.id),
    [changePublisher]
  );

  return (
    <RHFAutoCompleteVirtualize
      name={'publisherId'}
      options={publishers}
      getOptionLabel={option => option.label ?? t('Unknown')}
      textFieldProps={{
        label: t('Publisher'),
        placeholder: t('[ Search and Select Publisher ]'),
        margin: 'dense',
      }}
      onChange={handlePublisherChange}
      disableClearable
      textFieldReadOnly
      data-test="publisher-dropdown"
      disabled={!isReportGenerated}
    />
  );
}
